import React from 'react';

import {
  Box,
  FormControlLabel,
  Typography,
} from '@mui/material';

import { COLOR_BORDER, COLOR_DARK } from '~/components/App/theme';
//import { WarningIcon } from '~/components/icons';
import { Radio } from '~/components/Radio';
import { Tooltip } from '~/components/Tooltip';
import { IConfigurationOption } from '~/domain/IConfigurationOption';
//import { IConfigurationOptionInteriorColors } from '~/domain/IConfigurationOptionInteriorColors';
interface IConfigurationPack {
  pack: IConfigurationOption;
}

export const ConfigurationPackColors = React.memo<IConfigurationPack>(
  function ConfigurationPackColors(props) {
    const { pack } = props;

    return (
      <Box
        sx={({ palette: { background } }) => ({
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          minWidth: 0,
          color: COLOR_DARK,
          background: background.default,
          borderTop: `1px solid ${COLOR_BORDER}`,
        })}
      >
        <FormControlLabel
          value={pack.code}
          control={<Radio color="secondary" />}
          label={(
            <Tooltip title={`${pack.code}: ${pack.name}`}>
              <Typography component="span">
                {/* {pack.code}: {pack.name} */}
                {pack.name}
              </Typography>
            </Tooltip>
          )}
          sx={{
            display: 'flex',
            m: 0,
            flex: 1,
            minWidth: 0,
          }}
          componentsProps={{
            typography: {
              noWrap: true,
            },
          }}
        />
        {/* <Tooltip title="Switching to this option will cause a conflict of the configuration" sx={{ width: 221 }}>
          <WarningIcon
            sx={({ palette: { warning } }) => ({
              flexShrink: 0,
              width: 25,
              height: 22,
              m: '0 10px',
              visibility: pack.isValid ? 'hidden' : 'visible',
              path: {
                fill: warning.dark,
              },
            })}
          />
        </Tooltip> */}
      </Box>
    );
  }
);
